<template>
  <v-container
    id="regular-tables"
    fluid
    tag="section"
  >
    <base-material-card
      color="light-blue"
      icon="mdi-account-tie"
      title="Ofertas"
      class="px-5 py-3"
    >
      <v-data-table
        v-if="ofertaslist"
        :headers="headers"
        :items="ofertas"
        :search="search"
        :loading="loading"
        :must-sort="true"
        class="elevation-1 mb-10"
      >
        <template v-slot:top>
          <v-toolbar
            flat
            color="white"
          >
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Buscar"
              single-line
              hide-details
            />
            <v-spacer />
            <v-btn
              color="primary"
              fab
              dark
              small
              class="mb-2 mr-3"
              @click="addOfertas()"
            >
              <v-icon
                dark
              >
                mdi-plus
              </v-icon>
            </v-btn>
            <v-btn
              color="red"
              fab
              dark
              small
              class="mb-2"
              @click="reportModalTrigger()"
            >
              <v-icon dark>
                mdi-file-chart
              </v-icon>
            </v-btn>
          </v-toolbar>
        </template>
        <template v-slot:item="{ item }">
          <tr
            v-if="item.estado == 'PENDIENTE'"
            class="pendient"
          >
            <td>{{ item.fecha }}</td>
            <td>{{ item.ofertante_name }}</td>
            <td>{{ item.oferta | recorte }}</td>
            <td>{{ item.condiciones }}</td>
            <td>{{ item.estado }}</td>
            <td>
              <v-icon
                small
                class="mr-2"
                color="success"
                @click="editItem(item)"
              >
                mdi-pencil-outline
              </v-icon>
              <v-icon
                small
                color="error"
                @click="deleteItem(item)"
              >
                mdi-delete
              </v-icon>
              <v-icon
                small
                class="mr-2"
                color="info"
                @click="printer(item)"
              >
                mdi-printer
              </v-icon>
            </td>
          </tr>
          <tr
            v-else-if="item.estado == 'CURSO' || item.estado == 'EN CURSO'"
            class="oncourse"
          >
            <td>{{ item.fecha }}</td>
            <td>{{ item.ofertante_name }}</td>
            <td>{{ item.oferta | recorte }}</td>
            <td>{{ item.condiciones }}</td>
            <td>{{ item.estado }}</td>
            <td>
              <v-icon
                small
                class="mr-2"
                color="success"
                @click="editItem(item)"
              >
                mdi-pencil-outline
              </v-icon>
              <v-icon
                small
                color="error"
                @click="deleteItem(item)"
              >
                mdi-delete
              </v-icon>
              <v-icon
                small
                class="mr-2"
                color="info"
                @click="printer(item)"
              >
                mdi-printer
              </v-icon>
            </td>
          </tr>
          <tr
            v-else
            class="finalize"
          >
            <td>{{ item.fecha }}</td>
            <td>{{ item.ofertante_name }}</td>
            <td>{{ item.oferta | recorte }}</td>
            <td>{{ item.condiciones }}</td>
            <td>{{ item.estado }}</td>
            <td>
              <v-icon
                small
                class="mr-2"
                color="success"
                @click="editItem(item)"
              >
                mdi-pencil-outline
              </v-icon>
              <v-icon
                small
                color="error"
                @click="deleteItem(item)"
              >
                mdi-delete
              </v-icon>
              <v-icon
                small
                class="mr-2"
                color="info"
                @click="printer(item)"
              >
                mdi-printer
              </v-icon>
            </td>
          </tr>
        </template>
      </v-data-table>
      <addOfertas
        :edited-item="datos"
        :edited-index="editedIndex"
      />
      <modalReportOfertas
        :show-dialog="showModalReport"
        @close-action="reportModalTrigger"
      />
    </base-material-card>
  </v-container>
</template>

<script>
  import Vue from 'vue'
  import addOfertas from './addOfertas.vue'
  import modalReportOfertas from './modalReportOfertas.vue'
  function parseDateValue (dateStr) {
    if (!dateStr) return 0
    if (typeof dateStr !== 'string') return new Date(dateStr).getTime() || 0

    const str = dateStr.trim()
    if (!str) return 0

    if (str.includes('/') || str.includes('-')) {
      const delimiter = str.includes('/') ? '/' : '-'
      const parts = str.split(delimiter)
      if (parts.length === 3) {
        if (parts[2].length === 4) {
          const day = parseInt(parts[0], 10)
          const month = parseInt(parts[1], 10) - 1
          const year = parseInt(parts[2], 10)
          return new Date(year, month, day).getTime() || 0
        }
        if (parts[0].length === 4) {
          const year = parseInt(parts[0], 10)
          const month = parseInt(parts[1], 10) - 1
          const day = parseInt(parts[2], 10)
          return new Date(year, month, day).getTime() || 0
        }
      }
    }

    const timestamp = Date.parse(str)
    return isNaN(timestamp) ? 0 : timestamp
  }

  function sortText (a, b) {
    const valA = a ? a.toString().trim() : ''
    const valB = b ? b.toString().trim() : ''
    return valA.localeCompare(valB, 'es', { numeric: true, sensitivity: 'base' })
  }

  export default {
    name: 'OfertasTable',
    components: {
      addOfertas,
      modalReportOfertas,
    },
    data: vm => {
      return {
        search: '',
        snackbar: false,
        colorSnak: 'info',
        text: '',
        timeout: 3000,
        datos: {},
        editedIndex: -1,
        headers: [
          {
            text: 'Fecha',
            align: 'left',
            value: 'fecha',
            sort: (a, b) => parseDateValue(a) - parseDateValue(b),
          },
          {
            text: 'Ofertante',
            align: 'left',
            value: 'ofertante_name',
            sort: sortText,
          },
          {
            text: 'Oferta',
            align: 'left',
            sortable: false,
            filterable: false,
            value: 'oferta',
          },
          {
            text: 'Condiciones',
            align: 'left',
            sortable: false,
            filterable: false,
            value: 'condiciones',
          },
          {
            text: 'Estado',
            align: 'left',
            value: 'estado',
            sort: sortText,
          },
          {
            text: 'Acciones',
            value: 'acciones',
            sortable: false,
            filterable: false,
          },
        ],
        emailRules: [
          v => !!v || 'EL correo electrónico es requerido',
          v => /.+@.+\..+/.test(v) || 'Ingresa un correo valido',
        ],
        showModalReport: false,
      }
    },
    computed: {
      ofertaslist: {
        get () {
          return this.$store.state.ofertas.ofertaslist
        },
      },
      ofertas: {
        get () {
          return this.$store.state.ofertas.ofertas
        },
        set (value) {
          return this.$store.commit('ofertas/setOfertas', value)
        },
      },
      loading: {
        get () {
          return this.$store.state.ofertas.loading
        },
      },
    },
    mounted () {
      this.$store.dispatch('ofertas/getOfertas')
      this.$store.dispatch('ofertantes/getOfertantes')
    },
    methods: {
      addOfertas () {
        this.datos = {}
        this.editedIndex = -1
        this.$store.commit('ofertas/setRegister', true)
      },
      editItem (item) {
        this.editedIndex = this.ofertas.indexOf(item)
        this.datos = Object.assign({}, item)
        this.$store.commit('ofertas/setRegister', true)
      },
      deleteItem (item) {
        this.$confirm('Está seguro que desea eliminar el registro?', {
          buttonTrueText: 'Si',
          buttonFalseText: 'No',
        })
          .then(res => {
            if (res) {
              this.$store.dispatch('ofertas/deleteOfertas', item.id)
                .then((response) => {
                  Vue.notify({
                    group: 'loggedIn',
                    text: response.data.success,
                    type: 'teal accent-3',
                    duration: 5000,
                  })
                })
                .catch(err => {
                  // eslint-disable-next-line
                  console.log(err)
                  Vue.notify({
                    group: 'loggedIn',
                    text: 'No se pudo eliminar en este momento',
                    type: 'red accent-2',
                    duration: 5000,
                  })
                },
                )
            }
          })
      },
      forceFileDownload (response, nombre) {
        const url = window.URL.createObjectURL(new Blob([response.data]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', nombre)
        document.body.appendChild(link)
        link.click()
      },
      async printer (item) {
        var response = await this.$store.dispatch('ofertas/printer', item.id)
        this.forceFileDownload(response, 'oferta_' + item.ofertante_name.replace(' ', '_') + '_report.pdf')
      },
      reportModalTrigger () {
        this.showModalReport = !this.showModalReport
      },
    },

  }
</script>

<style>
  .v-card {
    margin-top: 0px;
    margin-bottom: 0px;
  }
  .pendient {
    color: #ff2f00;
  }
  .oncourse{
    color: #0080ff;
  }
  .finalize{
    color: #005e49;
  }
</style>
